export const contact = {
  title: 'Contacto',
  routingNotice: 'Aviso de Enrutamiento',
  routingText: 'Las consultas operativas deben dirigirse a la empresa participada correspondiente.',
  email: 'Correo Electrónico',
  address: 'Dirección Postal',
  phone: 'Teléfono',
  placeholders: {
    email: '[EMAIL]',
    address: '[DIRECCIÓN]',
    phone: '[TELÉFONO]'
  }
};
